import { Component, OnInit } from '@angular/core';

import { AuthorizeService } from 'src/api-authorization/authorize.service';
import { UserSettings } from 'src/models/player.model';
import { UserService } from 'src/services/user.service';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss']
})
export class NavMenuComponent implements OnInit {
  isExpanded = false;
  public isAuthenticated: boolean = false;
  public userSettings: UserSettings[] = [];
  public isTiebreakTourney: boolean = false;


  constructor(private authorizeService: AuthorizeService, private userSvc: UserService) {
  }

  ngOnInit(): void { }
  isRunning: boolean = false;
  ngAfterViewInit(): void {
    this.authorizeService.isAuthenticated().subscribe(bFlag => {
      this.isAuthenticated = bFlag;
      if (this.isAuthenticated) {
        if (!this.isRunning) {
          this.isRunning = true;
          this.userSvc.getLaddersAndLevels().subscribe(
            (resp) => {
              this.userSettings = resp;
              this.isRunning = false;
            }
          );
          this.userSvc.getUser().subscribe(
            (resp1) => {
              this.isTiebreakTourney = resp1.ladderType == 'Tiebreak';

            }
          );

        }
      }
    });
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }
}
